define([
	"dojo/_base/declare",
	"Apparel/NewMaterialSample"
], function(declare,NewMaterialSample) {

	return declare(NewMaterialSample, {
		bUpdateParent: false,

		onCreatePopup: function(/*csi.view.Widget*/view) {
			// summary: set default value for request level
			view.addFixedValue("SampleStorage", this.m_urlParent);
			view.cacheView.cacheNode(this.getParent());
			this.inherited(arguments);
		}
	});
});